import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', () => {
  const isOnBoardingActive = ref<boolean>(false)
  const isPwaInstallable = ref<boolean>(false)

  const ONBOARDING_COMPLETED_KEY = 'minimind_onboarding_completed'

  async function initializeApp() {
    const onBoardingCompleted = localStorage.getItem(ONBOARDING_COMPLETED_KEY)
    if (onBoardingCompleted) return
    isOnBoardingActive.value = true
  }

  async function startOnboarding(): Promise<void> {
    isOnBoardingActive.value = true
  }

  function finishOnboarding() {
    isOnBoardingActive.value = false
    localStorage.setItem(ONBOARDING_COMPLETED_KEY, 'true')
  }

  function setPwaPrompt() {
    isPwaInstallable.value = true
  }

  return {
    isOnBoardingActive,
    isPwaInstallable,
    initializeApp,
    startOnboarding,
    finishOnboarding,
    setPwaPrompt
  }
})
